import { IDeviceOutputDto } from './device-output-dto.interface';

export interface IPlatformOutputDto {
    id: number;
    externalId: string;
    name: string;
    devices?: IDeviceOutputDto[];
}
